const LETTERS_V1_STEP = 'lettersV1';
const LETTERS_V2_STEP = 'lettersV2';
const LETTERS_V3_STEP = 'lettersV3';

export {
    LETTERS_V1_STEP,
    LETTERS_V2_STEP,
    LETTERS_V3_STEP
};
